import { render, staticRenderFns } from "./commonVideoUpload.vue?vue&type=template&id=2382d9ed&scoped=true&"
import script from "./commonVideoUpload.vue?vue&type=script&lang=js&"
export * from "./commonVideoUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2382d9ed",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\CRM\\Client2026\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2382d9ed')) {
      api.createRecord('2382d9ed', component.options)
    } else {
      api.reload('2382d9ed', component.options)
    }
    module.hot.accept("./commonVideoUpload.vue?vue&type=template&id=2382d9ed&scoped=true&", function () {
      api.rerender('2382d9ed', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/cms/common/commonVideoUpload.vue"
export default component.exports